import { render, staticRenderFns } from "./Otros.vue?vue&type=template&id=da9950e6&scoped=true"
import script from "./Otros.vue?vue&type=script&lang=js"
export * from "./Otros.vue?vue&type=script&lang=js"
import style0 from "./Otros.vue?vue&type=style&index=0&id=da9950e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da9950e6",
  null
  
)

export default component.exports